import React from "react";
import {useNavigate} from "react-router-dom";
import Icon from "./ui/Icon";

const UnauthorizedMessage = ({text = "Log in to chat with friends, send friend requests and keep your games."}) => {
    const navigate = useNavigate();
    return (
        <div className="card card-pad">
            <div className="empty-state">
                <Icon name="user"/>
                <strong>You need to be logged in for this</strong>
                <span>{text}</span>
                <button className="btn btn-primary" style={{marginTop: "0.6rem"}} onClick={() => navigate("/my-profile")}>
                    <Icon name="login"/> Log in or create an account
                </button>
            </div>
        </div>
    )
}

export default UnauthorizedMessage;
